import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../api/authApi';
import { useAppDispatch } from '../../../store';
import { setAuthResponse } from '../state/authSlice';
import { toast } from 'react-toastify';
import { Input } from '../../../components/Input';
import { Button } from '../../../components/Button';
import { ErrorDataMessage } from '../../../api/baseQuery';

export const useLoginForm = (isGoogleCallbackLoading?: boolean) => {
  const dispatch = useAppDispatch();
  const [login, { error, isLoading }] = useLoginMutation();
  const navigate = useNavigate();
  const [values, setValues] = useState({
    email: '',
    password: ''
  });

  const onLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const res = await login({ email: values.email, password: values.password }).unwrap();
      dispatch(setAuthResponse(res));
      navigate('/books');
      toast('Logged in successfully', { type: 'success' });
    } catch (err) {
      return err;
    }
  };

  const errorData = error?.data as ErrorDataMessage;

  const LoginForm = (
    <form className="flex flex-col gap-4 w-full" onSubmit={onLogin}>
      <Input
        label="Email"
        value={values.email}
        placeholder="email@example.com"
        type="email"
        name="email"
        onChange={(e) => {
          setValues((prev) => ({ ...prev, email: e.target.value }));
        }}
        error={errorData?.email?.[0]}
        required
      />
      <Input
        label="Password"
        value={values.password}
        type="password"
        placeholder="password"
        onChange={(e) => {
          setValues((prev) => ({ ...prev, password: e.target.value }));
        }}
        error={errorData?.password?.[0]}
        required
      />

      <Link to="/forgot-password" className="text-right text-cyan-700 font-bold text-sm underline">
        Forgot password?
      </Link>

      <Button type="submit" isLoading={isLoading || isGoogleCallbackLoading}>
        Sign in
      </Button>
    </form>
  );
  return { LoginForm, isLoading };
};
